import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I suck at [formal] education or does education suck?",
  "description": "",
  "published": "2011-10-04T00:00:00.000Z",
  "redirect_from": ["/blog/i-suck-at-formal-education-or-does-education-suck/swizec/2564"],
  "categories": "Academic term, Education, Education Reform, Learning, Learning Theories, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/3954094115_0f1a0e6a98_m9.jpg",
        "alt": "Animal Development",
        "title": "Animal Development"
      }}></img></p>
    <p>{`There is probably a trend where I make a post about education every year around October, January and June. It corresponds nicely with the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Academic_term",
        "title": "Academic term"
      }}>{`school year`}</a>{` and how `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Test_%28assessment%29",
        "title": "Test (assessment)"
      }}>{`exams`}</a>{` are laid out.`}</p>
    <p>{`But this time the post is going to be different:`}</p>
    <ul>
      <li parentName="ul">{`this is not a rant`}</li>
      <li parentName="ul">{`this does not propose a solution`}</li>
      <li parentName="ul">{`this is just a set of observations`}</li>
    </ul>
    <p>{`To give a bit of background: last year I advanced into the next year (set of two semesters) of my course through a little bit of dumb luck because the terms of advancing were lowered somewhat so enough of us could get through to fill up the year. This meant that I had a lot of exams left over and through naught other than poor planning, too many difficult exams stacked up to September and I subsequently failed catastrophically and was forced to transfer to a three year bachelor's course within a new education system.`}</p>
    <p>{`Wow ... that was a mouthful. I hope anyone understood even a fragment of that.`}</p>
    <p>{`And now the observations:`}</p>
    {
      /*more*/
    }
    <ol>
      <li parentName="ol">{`I have always been very interested in learning new things. Spending frustrating amounts of time to figure out how something works has never been a problem and I have probably spent more time learning things on my own than in a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Education",
          "title": "Education"
        }}>{`formal education`}</a>{` setting.`}</li>
      <li parentName="ol">{`I have never been very good at passing exams of any kind. If you ask me to display a certain skill at a particular moment in time ... I will fail. The last time this wasn't a problem was in 5th grade of primary school. Why, I don't know.`}</li>
      <li parentName="ol">{`I have always had trouble following a forced pace of learning. It tends to be too generally applicative and usually ends up being too slow for me. Because it doesn't tax me enough, I tend to drift away and start learning things on my own. Then I get pulled away by learning shiny cool things and forget to follow along with the formal education. (like when you're reading a book and your mind drifts)`}</li>
      <li parentName="ol">{`Invariably because I don't follow along a formal class eventually surpasses my ability to quickly get back on track and I fall behind.`}</li>
      <li parentName="ol">{`I can usually learn a whole semester worth of a formal class in about two weeks of concentrated studying, but exams are always set up in such a way as to make it impossible to concentrate on a single class for two weeks ... you're supposed to follow along for the whole 3 months.`}</li>
      <li parentName="ol">{`I get genuinely excited about most theoretical and practical things they want to teach/show us at school`}</li>
      <li parentName="ol">{`The productive output of most of my classmates is abysmal`}</li>
      <li parentName="ol">{`The forced productive output of most of my classmates makes me want to scream when I look at it`}</li>
      <li parentName="ol">{`Most of my classmates get genuinely frustrated when asked to produce something significant-ish or learn a completely new concept`}</li>
      <li parentName="ol">{`A lot of my classmates passed their exams and advanced into the next year. Even the ones I have personally worked with on coursework and shouldn't be more than freshmen if it were up to me`}</li>
      <li parentName="ol">{`A favourite professor of mine can't hold class this year because the `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Peer_review",
          "title": "Peer review"
        }}>{`peer review process`}</a>{` in his field is slow and he didn't meet some arbitrarily defined quota for published articles`}</li>
    </ol>
    <p>{`You can draw your own conclusions. Mine is that the education system as I know it is designed to prefer a different set of skills than I posses and for whatever reason I have so far been unable to hack the system to my advantage.`}</p>
    <p>{`But I shan't let this discourage me. I'm going to graduate with a bachelor's in computer science by next October if it kills me ... even if I originally signed up for a master's equivalent.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dougbelshaw.com/blog/2011/10/02/what-did-we-learn-during-a-semester-of-learning-on-openbadges-over-at-p2pu-org/"
        }}>{`What did we learn during a 'semester of learning' on #openbadges over at P2PU.org?`}</a>{` (dougbelshaw.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.telegraph.co.uk/education/educationnews/8790219/Ofqual-pupils-to-sit-end-of-course-exams-in-GCSE-overhaul.html&a=56349834&rid=12e58db3-0284-45bd-89fb-8ec7d196d2a6&e=5a9b97ac01528ab2a58db3ce37412cb8"
        }}>{`Ofqual: pupils to sit end-of-course exams in GCSE overhaul`}</a>{` (telegraph.co.uk)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://beautifoolmind.wordpress.com/2011/09/29/a-world-with-no-exams/"
        }}>{`A World With No Exams!`}</a>{` (beautifoolmind.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.downes.ca/post/56328/rd"
        }}>{`Invisible Learning, Aprendizaje Invisible`}</a>{` (downes.ca)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jameslcarey.com/2011/10/03/todays-gripe-the-end-of-excellence/"
        }}>{`Today's Gripe: The End of Excellence`}</a>{` (jameslcarey.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bripblap.com/friday-quote-self-education/"
        }}>{`friday quote: self-education`}</a>{` (bripblap.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bloomsight.wordpress.com/2011/10/02/education-a-poem/"
        }}>{`Education, a poem.`}</a>{` (bloomsight.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=12e58db3-0284-45bd-89fb-8ec7d196d2a6",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      